import { h } from '@stencil/core';
export class PesSoftwareModal {
  constructor() {
    this.columns = [];
    this.data = [];
    this.viewDownloadCellEnabled = false;
    this.labels = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    if (this.viewDownloadCellEnabled) {
      this.columns.push({ label: '', type: 'onlineLink' }, { label: '', type: 'link' });
    }
    return (h("div", { class: "pes-software-modal" }, this.columns.length > 0 && h("pes-software-modal-header-row", { columns: this.columns }), Array.isArray(this.data) && this.data.map(({ cells, fileType, link, documentReference, documentName, documentType, downloadAll, files, }) => {
      if (this.viewDownloadCellEnabled) {
        cells.push({ text: '', type: 'onlineLink' }, { text: '', type: 'link' });
      }
      return (h("pes-software-modal-row", { cells: cells, fileType: fileType, link: link, documentReference: documentReference, documentName: documentName, documentType: documentType, class: "pes-software-modal__row", labels: this.labels, downloadAll: downloadAll, files: files }));
    })));
  }
  static get is() { return "pes-software-modal-content"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-software-modal-content.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-software-modal-content.css"]
    };
  }
  static get properties() {
    return {
      "columns": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Array<PESSoftwareModalColumn>",
          "resolved": "PESSoftwareModalColumn[]",
          "references": {
            "Array": {
              "location": "global"
            },
            "PESSoftwareModalColumn": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Array of data for table header"
        },
        "defaultValue": "[]"
      },
      "data": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "ReadonlyArray<PESSoftwareModalRow>",
          "resolved": "readonly PESSoftwareModalRow[]",
          "references": {
            "ReadonlyArray": {
              "location": "global"
            },
            "PESSoftwareModalRow": {
              "location": "import",
              "path": "./types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Array of data for table body"
        },
        "defaultValue": "[]"
      },
      "viewDownloadCellEnabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Ability to add View/Download cell"
        },
        "attribute": "view-download-cell-enabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Record<string, string>",
          "resolved": "{ [x: string]: string; }",
          "references": {
            "Record": {
              "location": "global"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      }
    };
  }
  static get elementRef() { return "el"; }
}
